(function (angular) {
  "use strict";

  angular.module("app").service("ConnectRequestsApi", ConnectRequestsApi);

  ConnectRequestsApi.$inject = [
    "$resource",
    "settings",
    "UsersApi",
    "extendResource",
  ];

  function ConnectRequestsApi($resource, settings, UsersApi, extendResource) {
    /**
     * Adds extra methods and values
     * @return {this}
     */
    function transform() {
      // transform "user_to" or "user_from" into users resources
      if (this.user_to) {
        this.user_to = new UsersApi(this.user_to);
      }
      if (this.user_from) {
        this.user_from = new UsersApi(this.user_from);
      }

      return this;
    }

    // create the resource
    var resource = $resource(
      settings.apiBase + "/connect-requests/:id",
      {
        id: "@id",
      },
      {
        query: {
          method: "GET",
          isArray: false,
          transformResponse: function (response) {
            if (typeof response === "string") {
              response = JSON.parse(response);
            }

            if (Array.isArray(response.data)) {
              angular.forEach(response.data, function (connectRequest) {
                transform.call(connectRequest);
              });
            } else {
              if (response.data) {
                transform.call(response.data);
              }
            }
          },
        },
        save: {
          method: "POST",
          isArray: false,
        },
        update: {
          method: "PUT",
          isArray: false,
        },
        delete: {
          method: "DELETE",
        },
      },
    );
    resource.prototype.transform = transform;

    return extendResource(resource);
  }
})(angular);
